module.exports = __webpack_public_path__ + "static/media/menu_createRole_hoverActive.6ce581e6.svg";